import { PartialBrief } from '../../../../../Types/Brief'
import { Audience } from '../../../../../Types/generated-types'
import { AudienceFieldValues } from '../../LF/Audience/AudienceInput'
import ATTRIBUTES_BY_EVENT_TYPE from './attributesByEventType'

export const getDefaultAudience = (
  eventType: PartialBrief['collectionName']
): AudienceFieldValues => ATTRIBUTES_BY_EVENT_TYPE[eventType ?? '']?.defaultAudience ?? ''

export const getForcedAudience = (
  eventType: PartialBrief['collectionName']
): Audience | undefined => ATTRIBUTES_BY_EVENT_TYPE[eventType ?? '']?.forceAudience

export const getForcedLayout = (eventType: PartialBrief['collectionName']) =>
  ATTRIBUTES_BY_EVENT_TYPE[eventType ?? '']?.forceLayout
